let update = (el, {value}) => {
    if (value) {
        el.classList.add('disabled');
    } else {
        el.classList.remove('disabled');
    }
};

export default {
    bind: update,
    update: update,
};